import confetti from 'canvas-confetti';

// Celebrate when package is picked up
export const celebratePickup = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6']
  });
};

// Big celebration for milestones (100th package, etc.)
export const celebrateMilestone = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#10b981', '#3b82f6', '#f59e0b']
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#ef4444', '#8b5cf6', '#ec4899']
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

// Quick burst for successful actions
export const quickBurst = () => {
  confetti({
    particleCount: 50,
    spread: 40,
    origin: { y: 0.7 }
  });
};
